import ApiService from "./apiService";
import config from "../config/config";
import { apiConfig } from "../config/apiConfig";
import { sharedData } from "../sharedData/sharedData";

class UtilityService {
    static instance;

    constructor () {
        if (!UtilityService.instance) {
            this.instance = this;
            this.baseUrl = config['backend-url'].endsWith('/') ? config['backend-url'].slice(0, -1) : config['backend-url'];
            this.useToken = true;
            this.dontUseToken = false;
            this.apiService = new ApiService(this.baseUrl);
        }
        return UtilityService.instance;
    }

    async sendMail(payload) {
        const response = await this.apiService.post(
          apiConfig.sendMail,
          payload,
          this.useToken
        );
      
        if (response.ok) {
          return response.data;
        } else {
          const errorMessage = response?.data?.error || `HTTP ${response.status}`;
          throw new Error(errorMessage);
        }
      }

    // Diligence belongs to a request, not to a counterparty: two requests can share one
    // entity, and an entity-scoped write changes the other deal's diligence too. The
    // requestId is sent here rather than at the four call sites so none of them can
    // forget it; the backend writes Request.RequestStatus_Type (the source of truth) and
    // keeps Entity.Deligence_status only as a denormalised copy.
    async updateDiligenceStatus (entityId, diligenceStatus, requestId = null) {
        const response = await this.apiService.post(
            apiConfig.update_diligence,
            {
                entityId: entityId,
                deligenceStatus: diligenceStatus,
                requestId: requestId || sharedData.get("requestId"),
            },
            this.useToken
        )

        return response;
    }

};

export const utilityService = new UtilityService();